/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : product-listing-actions.d.ts
*
* Project Title : Checkout
*
* Description   :
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       :
*
* @Date         :
*
* @Version      : Version 1.0
*
 *
 * By            : H224423
 * On            : Mar 26, 2020
 * Description   : Added Modification History. Updated product service with sold to parameter
 *
 * By            : E844276
 * On            : Aug 04, 2020
 * Description   : Removed accountType and OEM parameters for custom pricing
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
*******************************************************************************/

import Action from './Action'
import ActionConstants from '../action-constants';
import ProductListingAPI from '../../API/product-listing-api';
import CheckoutConstants from '../../constants/checkout-constants';
import { ProductListingParams } from '../../../../../types';
import { SelectCategoryValue, CategoryListingAPIRes, SearhcResultSet } from 'modules/checkout/PurchaseSoftware';
import CategoryListingAction from './category-listing-actions';
import ProductSearchServices from '../../services/ProductSearchServices';

class ProductListing extends Action {

    static setSelectedCategory(value: SelectCategoryValue) {
        return (dispatch) => {
            dispatch(CategoryListingAction.setCategorySelected(value))
            if (value.categoryId === CheckoutConstants.DEFAULT_CATEGORY) {
                // Hit default products URL
                dispatch(ProductListing.getProductsForListing());
            } else {
                const params = {
                    categoryId: value.categoryId,
                    system: value.system,
                }
                dispatch(ProductListing.getProductsForListing(params));
            }
        }
    }

    static getProductsForListing(categoryFilter: ProductListingParams = {}) {
        return (dispatch, getState) => {
            dispatch(ProductListing.dispatchGetProducts());
            categoryFilter.soldTo = categoryFilter.soldTo ? categoryFilter.soldTo : (getState().selectAccount.selectAccountDetails.payload.soldTo ? getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber : '');
            ProductListingAPI.getProductListing(categoryFilter).then(response => {
                dispatch(ProductListing.dispatchProductListing(response, categoryFilter));
            }).catch(error => dispatch(ProductListing.dispatchProductListingError(error)));
        }
    }

    static searchProducts(searchTerm: string) {
        return (dispatch, getState: Function) => {
            dispatch(ProductListing.dispatchGetProducts());
            const categoryFilter: ProductListingParams = getState().categories.payload.selectedCategory;
            const productsListing: CategoryListingAPIRes = getState().products.payload.productListing.data;
            return new Promise((resolve, reject) => {
                try {
                    const response: SearhcResultSet = ProductSearchServices.getMatchedProducts(productsListing.categories, searchTerm.trim());
                    productsListing.categories = response.results;
                    productsListing.matchedAny = response.matchedAny;
                    productsListing.searchTerm = searchTerm;
                    dispatch(ProductListing.dispatchProductListing(productsListing, categoryFilter));
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        }
    }

    private static dispatchProductListing(response: CategoryListingAPIRes, categoryFilter: ProductListingParams) {
        return {
            type: ActionConstants.SET_PRODUCT_LISTING,
            payload: {
                response,
                selectedCategory: categoryFilter.categoryId ? {
                    categoryId: categoryFilter.categoryId,
                    system: categoryFilter.system,
                } : {
                        categoryId: 'default',
                        system: '',
                    },
            }
        }
    }

    private static dispatchGetProducts() {
        return {
            type: ActionConstants.GET_PRODUCT_LISTING,
            payload: {
                isFetching: true,
            }
        };
    }



    private static dispatchProductListingError(error) {
        return {
            type: ActionConstants.SET_PRODUCT_LISTING_ERROR,
            payload: {
                error
            }
        }
    }


}

export default ProductListing;